import { useEffect, useState } from 'react';

interface FontSelectorProps {
  selected: string;
  onSelect: (font: string) => void;
  disabled?: boolean;
}

// Curated Google Fonts that work well for map posters
export const FONT_OPTIONS = [
  { id: 'Roboto', name: 'Roboto' },
  { id: 'Montserrat', name: 'Montserrat' },
  { id: 'Playfair Display', name: 'Playfair' },
  { id: 'Oswald', name: 'Oswald' },
  { id: 'Raleway', name: 'Raleway' },
  { id: 'Lora', name: 'Lora' },
  { id: 'Bebas Neue', name: 'Bebas' },
  { id: 'Cormorant Garamond', name: 'Cormorant' },
  { id: 'Space Mono', name: 'Space Mono' },
  { id: 'Archivo Black', name: 'Archivo' },
  { id: 'Crimson Text', name: 'Crimson' },
  { id: 'Work Sans', name: 'Work Sans' },
] as const;

export type FontId = typeof FONT_OPTIONS[number]['id'];

export const DEFAULT_FONT: FontId = 'Roboto';

// Preload all fonts
const FONTS_CSS_URL = `https://fonts.googleapis.com/css2?${FONT_OPTIONS.map(f => `family=${encodeURIComponent(f.id)}:wght@700`).join('&')}&display=swap`;

export function FontSelector({ selected, onSelect, disabled }: FontSelectorProps) {
  const [fontsLoaded, setFontsLoaded] = useState(false);

  // Load fonts on mount
  useEffect(() => {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = FONTS_CSS_URL;
    link.onload = () => setFontsLoaded(true);
    document.head.appendChild(link);

    return () => {
      document.head.removeChild(link);
    };
  }, []);

  return (
    <div className="space-y-3">
      <label className="text-primary-2-80 block text-sm font-medium">
        Font Style
      </label>

      <div className="grid grid-cols-3 gap-2">
        {FONT_OPTIONS.map((font) => (
          <button
            key={font.id}
            type="button"
            onClick={() => onSelect(font.id)}
            disabled={disabled}
            className={`rounded-md border px-2 py-3 text-center transition-all ${
              selected === font.id
                ? 'border-secondary-1 bg-secondary-1/5 ring-1 ring-secondary-1'
                : 'border-neutral-2-20 hover:border-neutral-2-40'
            } disabled:cursor-not-allowed disabled:opacity-50`}
          >
            <span
              className="text-primary-2-80 block text-lg tracking-wider"
              style={{
                fontFamily: fontsLoaded ? `"${font.id}", sans-serif` : 'sans-serif',
                fontWeight: 700,
              }}
            >
              Abc
            </span>
            <span className="text-neutral-2-60 mt-1 block text-[10px]">
              {font.name}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}
